const getSeasonalLogo = () => {
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const currentMonth = currentDate.getMonth()
    const currentDay = currentDate.getDate()

    // Christmas season: Dec 1 - Dec 26 (inclusive)
    if (currentMonth === 11 && currentDay >= 1 && currentDay <= 26) {
        return 'christmas'
    }

    // Valentine's season: Jan 15 - Feb 15 (inclusive)
    const startOfValentines = new Date(currentYear, 0, 15)
    const endOfValentines = new Date(currentYear, 1, 16)
    if (currentDate >= startOfValentines && currentDate < endOfValentines) {
        return 'valentines'
    }

    return 'default'
}
export default getSeasonalLogo
